import {
  IGetNotificationsFromStoreFailed,
  IGetNotificationsFromStoreStarted,
  IGetNotificationsFromStoreSuccess,
  IGetSystemMaintenanceFailed,
  IGetSystemMaintenanceSignalRSuccess,
  IGetSystemMaintenanceStarted,
  IGetSystemMaintenanceSuccess,
  ISetRBACConfigurationSuccess,
  ISignalRConnectionFailed,
  ISignalRConnectionStarted,
  ISignalRConnectionSuccess,
} from './actions';
import * as constants from 'shared/stateManagement/constants';
import { HubConnection } from '@microsoft/signalr';
import { INotificationFromStore } from 'shared/models/INotification.interface';
import { IErrorScreen } from 'shared/models/IErrorScreen.interface';
import { IRBACState } from './state';

export const sinalRConnectionStarted = (): ISignalRConnectionStarted => ({
  type: constants.SIGNALR_CONNECTION_STARTED,
});
export const sinalRConnectionSuccess = (
  signalRConnection: HubConnection | null
): ISignalRConnectionSuccess => ({
  type: constants.SIGNALR_CONNECTION_SUCCESS,
  payload: { signalRConnection },
});

export const sinalRConnectionFailed = (): ISignalRConnectionFailed => ({
  type: constants.SIGNALR_CONNECTION_FAILED,
});

export function getNotificationsFromStoreStarted(): IGetNotificationsFromStoreStarted {
  return {
    type: constants.GET_NOTIFICATIONS_FROM_STORE_STARTED,
  };
}

export function getNotificationsFromStoreSuccess(
  notificationsFromStore: INotificationFromStore[]
): IGetNotificationsFromStoreSuccess {
  return {
    type: constants.GET_NOTIFICATIONS_FROM_STORE_SUCCESS,
    payload: notificationsFromStore,
  };
}

export function getNotificationsFromStoreFailed(
  errorMessage: string
): IGetNotificationsFromStoreFailed {
  return {
    type: constants.GET_NOTIFICATIONS_FROM_STORE_FAILED,
    payload: errorMessage,
  };
}

export function GetSystemMaintenanceStarted(): IGetSystemMaintenanceStarted {
  return {
    type: constants.GET_SYSTEM_MAINTENANCE_STARTED,
  };
}

export function GetSystemMaintenanceSuccess(
  response: IErrorScreen
): IGetSystemMaintenanceSuccess {
  return {
    type: constants.GET_SYSTEM_MAINTENANCE_SUCCESS,
    payload: response,
  };
}

export function GetSystemMaintenanceFailed(
  response: IErrorScreen | null
): IGetSystemMaintenanceFailed {
  return {
    type: constants.GET_SYSTEM_MAINTENANCE_FAILED,
    payload: response,
  };
}

export function GetSystemMaintenanceSignalRSuccess(
  response: IErrorScreen
): IGetSystemMaintenanceSignalRSuccess {
  return {
    type: constants.GET_SYSTEM_MAINTENANCE_SIGNALR_SUCCESS,
    payload: response,
  };
}

export function SetRBACConfigurationSuccess(
  config: IRBACState
): ISetRBACConfigurationSuccess {
  return {
    type: constants.SET_RBAC_CONFIGURATION_SUCCESS,
    payload: config,
  };
}

export const actionTriggers = {
  sinalRConnectionSuccess,
  sinalRConnectionFailed,
  sinalRConnectionStarted,
  getNotificationsFromStoreStarted,
  getNotificationsFromStoreSuccess,
  getNotificationsFromStoreFailed,
  GetSystemMaintenanceStarted,
  GetSystemMaintenanceSuccess,
  GetSystemMaintenanceFailed,
  GetSystemMaintenanceSignalRSuccess,
  SetRBACConfigurationSuccess,
};
